module.exports = __webpack_public_path__ + "static/ss.a5645ea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/cuvinte/ss.png
// module id = 284
// module chunks = 270678402688933 277036769636407